/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { api } from "../api/httpClient";
import qs from "qs";
import { IListParams } from "@/interfaces/serviceInterface";
import { buildUrl } from "@/utils/bindUrl";
import {
  IApiKey,
  IResponseListApiKey,
  IResponseShowApiKey
} from "@/interfaces/apiKey";

const BASE = "/global/api-keys";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listApiKeys({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListApiKey>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showApiKey({
  id,
  includes,
}: { id: string | number } & Partial<IListParams>) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowApiKey>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createApiKey({ apiKey }: { apiKey: IApiKey }) {
  const { data } = await api.post<IResponseShowApiKey>(BASE, { apiKey });
  return data;
}

export async function updateApiKey({
  id,
  apiKey,
}: {
  id: string | number;
  apiKey: IApiKey;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowApiKey>(url, { apiKey });
  return data;
}

export async function deleteApiKey(id: string | number) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  await api.delete(url);
}
